// eslint-disable-next-line no-restricted-imports
import { useLocation } from "react-router-dom";

/**
 * Pathname from React Router. Prefer this over useLocation when you only need the path —
 * query string lives in Redux (useQueryParam), not location.search.
 */
export const useLocationPathname = (): string => {
  return useLocation().pathname;
};
